<template>
  <BaseModal :is-open="isOpenModal" size="md">
    <template #header>
      <NavBar>
        <template #right>
          <CloseButton
            data-testid="close-detail-modal"
            role="button"
            tabindex="0"
            aria-label="Fechar"
            @click="closeModal"
            @keydown.enter="closeModal"
          />
        </template>
      </NavBar>
    </template>
    <template #content>
      <div class="content">
        <SingleInput
          v-model="inputText"
          :placeholder="placeholderValue"
          :max-length="30"
          @input="handleChangePortfolioName"
          @keypress.enter.prevent
        />
        <BaseText class="content__counter" size="p6">{{ counter }}</BaseText>
      </div>
    </template>
    <template #footer>
      <footer class="footer">
        <ButtonPrimary
          label="Salvar"
          :loading="isLoading"
          @click="handleCreateWallet"
        />
      </footer>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import { ref, inject, computed } from 'vue';
import {
  BaseModal,
  BaseText,
  ButtonPrimary,
  NavBar,
  SingleInput
} from '@warrenbrasil/nebraska-web';
import { CloseButton } from '@/modules/common/components/buttons';

interface Props {
  isOpenModal: boolean;
  isTemplate?: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  (e: 'close', open: boolean): void;
}>();

const inputText = ref('');

const isLoading = ref(false);

const createWallet = inject('createWallet', async (name: string) => ({ name }));

const placeholderValue = computed(() => {
  return props.isTemplate ? 'Nome da carteira modelo' : 'Nome da carteira';
});

const counter = computed(() => {
  return `${inputText.value.length}/30`;
});

function handleChangePortfolioName(text: string) {
  if (text.trim() === '') {
    inputText.value = text.trim();
    return;
  }
  inputText.value = text;
}

async function handleCreateWallet() {
  try {
    isLoading.value = true;
    await createWallet(inputText.value ? inputText.value : 'Nova carteira');
  } finally {
    isLoading.value = false;
  }
}

function closeModal() {
  emit('close', true);
  inputText.value = '';
}
</script>

<style lang="less" scoped>
.content {
  padding: @size-spacing-x700 @size-spacing-x1000 @size-spacing-x700
    @size-spacing-x1000;

  &__counter {
    margin: @size-spacing-x300 0;
    text-align: right;
  }
}
.footer {
  display: flex;
  justify-content: center;
  align-items: center;

  padding: @size-spacing-x350 0;
  border-top: 1px solid @divider-primary;
}
:deep(.single-input__container) {
  padding: 0;
}
:deep(.single-input__text-block) {
  .text-p-2();
}
</style>
